import { users } from '@marketmuse/config/configs';
import AUTH_ROLES from '@marketmuse/config/types/authRoles';

export default {
  ADMIN: { ...users[AUTH_ROLES.ADMIN] },
  MM_CX_ADMIN: { ...users[AUTH_ROLES.MM_CX_ADMIN] },
  USER: { ...users[AUTH_ROLES.USER] },
  CLIENT: { ...users[AUTH_ROLES.CLIENT] },
};
